import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'sessions';
const BASE_PATH = `${API_ROOT}/sessions`;
const PATHS = {
    LIST: BASE_PATH,
};
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.vehicleId)
        params.append('vehicleId', props.vehicleId);
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return [CacheKey, 'list', props];
}
export default { CacheKey, list, listKey };
